// extracted by mini-css-extract-plugin
export default {"app-markdown":"AppMarkdown_app-markdown__CTiLZ"};